<div class="ui-product-add">
  <div class="ui-product-add-content" mat-dialog-content>
    
    <div class="ui-product-add-details">
      <object type="image/svg+xml" data="assets/images/icons/products-new.svg"></object>
      <h3 class="ui-title">Contratar plan</h3>
      <p>Seleccioná el plan comercial de tu interés, un asistente revisará tu solicitud y se contactará con vos.</p>
    </div>

    <form class="ui-dialog" [formGroup]="formData">
      <div class="ui-form">
        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Plan comercial</mat-label>
            <mat-select formControlName="plan">
              <mat-option *ngFor="let item of plansData" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('plan', 'validate')">{{formHasError('plan', 'message')}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-product-add-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
    <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Solicitar plan</button>
  </div>
</div>